module.exports = __webpack_public_path__ + "static/media/not-found.24274c09.gif";